import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import FreeTextInput from '../../atoms/FreeTextInput'
import FreeTextInputStateless from '../../atoms/FreeTextInputStateless'

const propTypes = {
  filters: PropTypes.array.isRequired, // one child per filterable item to control show-hides
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func,
  activeSearch: PropTypes.bool,
  buttonIsGrayWithNoInput: PropTypes.bool,
  searchFilterFontSize: PropTypes.string,
  showChip: PropTypes.bool,
  showSearchIconButton: PropTypes.bool,
}

const deafultProps = {
  handleSubmit: () => {},
}

const FreeTextInputGroupWrapper = styled.div``

const StyledFreeTextInput = styled(FreeTextInput)`
  margin: 12px 0;
`

const StyledFreeTextInputStateless = styled(FreeTextInputStateless)`
  margin: 12px 0;
`

const FreeTextInputGroup = ({
  filters,
  handleChange,
  handleSubmit,
  activeSearch,
  buttonIsGrayWithNoInput,
  showSearchIconButton,
  searchFilterFontSize,
  showChip,
}) => {
  const renderFreeTextInputItems = (filters, handleChange, handleSubmit) => {
    return filters.map((filter, index) => {
      const Component = filter.stateless ? StyledFreeTextInputStateless : StyledFreeTextInput
      return (
        <Component
          {...filter}
          activeSearch={activeSearch}
          searchFilterFontSize={searchFilterFontSize}
          buttonIsGrayWithNoInput={buttonIsGrayWithNoInput}
          freeTextInputId={`${filter.name}-freeTextInput-${index}`}
          key={`${filter.name}-freeTextInput-${index}`}
          handleChange={filter.handleChange || handleChange}
          handleSubmit={filter.handleSubmit || handleSubmit}
          showChip={showChip}
          showSearchIconButton={showSearchIconButton}
        />
      )
    })
  }

  return (
    <FreeTextInputGroupWrapper>
      {renderFreeTextInputItems(filters, handleChange, handleSubmit)}
    </FreeTextInputGroupWrapper>
  )
}

FreeTextInputGroup.propTypes = propTypes
FreeTextInputGroup.defaultProps = deafultProps

export default FreeTextInputGroup
